// extracted by mini-css-extract-plugin
export default {"rootInputSelect":"InputOptionMulti_rootInputSelect__TW5-m","formControl":"InputOptionMulti_formControl__CLqy7","btnClear":"InputOptionMulti_btnClear__ZmqtP"};